const initialState = () => ({
  id: '',
  name: ''
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state, { id, name }) {
      state.id = id
      state.name = name
    }
  }
}
